export default __webpack_public_path__ + "static/media/n8n.e5a388d1.png";